module.exports = __webpack_public_path__ + "img/PHONE_CALL.b5b2db56.svg";